<template>
    <section>
        <h2 class="flex flex-col items-start gap-2 text-xl font-bold text-white py-2 sm:flex-row sm:items-center">
            {{ title }}
            <div class="flex flex-col gap-2 ml-auto w-full sm:flex-row sm:w-auto">
                <slot name="header-actions"></slot>
                <button
                    type="button"
                    class="primary sm:w-fit w-full sm:ml-auto"
                    @click="$emit('add')"
                >
                    {{ addLabel }}
                </button>
            </div>
        </h2>

        <app-table
            v-if="items.length > 0"
            :columns="columns"
            :data="items"
            :show-actions="true"
            :actions-column-label="$t('common.actions')"
            :sortable="false"
            :row-class-condition="rowClassCondition"
            class="pb-16"
        >
            <template v-slot:actions="{ item }">
                <slot name="actions" :item="item"></slot>
            </template>
        </app-table>
        <div v-else class="p-4 mb-16 bg-gray-700/20 text-white rounded-md text-center py-16">{{ $t('common.nothingYet') }}</div>
    </section>
</template>

<script>
import AppTable from '@/components/common/AppTable';

// One Setup block: title, "add" button, table with row actions and an empty state
export default {
    components: {
        AppTable,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        addLabel: {
            type: String,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        rowClassCondition: {
            type: Function,
            default: () => false,
        },
    },
    emits: ['add'],
};
</script>
